<template>
  <div>
    <b-container fluid class="pb-5 card-management">
        <b-row>
          <b-col xl="12" class="mb-2">
            <h3 class="pl-3 pt-3">{{ $t('Card Management') }}</h3>
            <div class="p-2 mb-4">
              <div class="fz-24 fw-600 p-2">{{ $t('Choose Your Prepaid Card') }}</div>
              <div class="row">
                <div class="col-12">
                  <step-container :current_step="3"></step-container>
                </div>                
              </div>
              <b-row class="d-flex justify-content-center complete-card">
                <b-col sm="12" md="6" class="my-4   text-center"> 
                  <svg width="200" height="200" class="checklist-complete">
                    <circle fill="#f8c617" stroke="none" stroke-width="20" cx="100" cy="100" r="95" class="circle" stroke-linecap="round"/>
                    <polyline fill="none" stroke="#fff" stroke-width="12" points="44,107 86,142 152,69" stroke-linecap="round" stroke-linejoin="round" class="tick" />
                  </svg>
                </b-col>
                <b-col sm="12" md="9" class="my-4   text-center"> 
                  <h1>Hooray your card request has been received!</h1>
                  <p class="mt-3 mb-4">
                    Our admin team will review the submission request. 
                    <br> 
                    Thank you for your patience!
                  </p>
                  <router-link to="/" tag="button">Back to Dashboard</router-link>
                </b-col>
              </b-row>  
            </div>
          </b-col>
        </b-row>
    </b-container>
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
  import LoaderComponent from "@/components/LoaderComponent";
  import stepContainer from "@/components/CardManagement/stepContainer";
  import confetti from "@/assets/js/confetti.js";

  var count = 200;
  var defaults = {
    origin: { x: .6, y:1 }
  };
  console.log(window.innerWidth/2)

  function fire(particleRatio, opts) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio)
    });
  }

  export default {
    name: 'card-management',
    data() {
      return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        isLoading:false
      }
    },
    components: {
      LoaderComponent,
      stepContainer
    },
    methods:{
      
    },
    mounted(){
      fire(0.25, {
        spread: 26,
        startVelocity: 55,
      });
      fire(0.2, {
        spread: 60,
      });
      fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8
      });
      fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2
      });
      fire(0.1, {
        spread: 120,
        startVelocity: 45,
      });
    }
  };
</script>
